export default "__VITE_ASSET__kV7P8YcI__"